import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';

import { PostulacionesService } from '../../services/postulaciones/postulaciones.service';

import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { environment } from '../../../environments/environment';
export interface DialogData 
{
    idGrupo: any,    
    fechaPago: any
    beneficiarios: any
}

@Component({
    selector: 'modal-info-pagada-beneficiario',
    templateUrl: '../../pages/common/modal-info-pagada-beneficiario.component.html',
    styleUrls: ['../../pages/common/postulacion-rechazar.css'],
})
export class ModalInfoPagadaBeneficiario
{  
    constructor( public dialogRef: MatDialogRef<ModalInfoPagadaBeneficiario>, 
                 private postulacionesService: PostulacionesService,
                 @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog, ) 
                 { }

    onCancelarClick(): void { this.dialogRef.close() }  

    openAlertDialog(mensaje: string, clase: string)  
    {
        this.dialog.open(AlertDialogComponent, { 
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }
}